var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',{staticStyle:{"width":"100%"},attrs:{"options":_vm.options,"props":{ expandTrigger: 'hover' ,value: 'dpt_id', label: 'name', children: 'children',checkStrictly:true},"clearable":""},on:{"change":_vm.handleChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }